import React from 'react';

export const CheckboxComponent = ({ propKey, value, disabled, handleClick }) => {
  const inputKey = propKey + 'input';
  const labelKey = propKey + 'label';

  return (
    <div>
      <input
        type="checkbox"
        key={inputKey}
        id={inputKey}
        checked={value || false}
        disabled={disabled}
        onChange={() => handleClick({ property: propKey, value: !value })}
      />
      <label key={labelKey} htmlFor={inputKey}>
        {value ? 'ON' : 'OFF'}
      </label>
    </div>
  );
};
